import React from 'react';
import { PiSunLight, PiMoonLight } from "react-icons/pi";

function DarkModeToggle({ isDark, setIsDark }) {
  return (
    <button type="button" onClick={() => setIsDark((prev) => !prev)} aria-label="Toggle dark mode">
      {isDark ? <PiSunLight className='text-3xl m-4' /> : <PiMoonLight className='text-3xl m-4' />}
    </button>
  );
}

export default DarkModeToggle;
